import { useQuery } from '@tanstack/react-query';

import { getCaseFieldHistory } from '~/services/ContractingService';

import type { ContractingFieldHistoryParams } from '~/types/services/contracting';

import { fieldHistoryQueryKeys } from './fieldHistoryQueryKeys';
import { retryUnlessRejected } from './retryUnlessRejected';

export function useGetCaseFieldHistory(caseNumber: string | undefined, params: ContractingFieldHistoryParams) {
  return useQuery({
    queryKey: fieldHistoryQueryKeys.case(caseNumber ?? '', params),
    queryFn: ({ signal }) => getCaseFieldHistory(caseNumber ?? '', params, { signal }),
    enabled: !!caseNumber,
    retry: retryUnlessRejected,
  });
}
